import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import CANADAflag from "../../../assets/Images/canada.png";
import usflag from "../../../assets/Images/us.png";
import {
  setDashboardChild,
  setMatchedLookupobj,
} from "../../../reduxApp/fieldStore";
import { styled } from "@mui/material/styles";
import {
  getCandidateById,
  updateCandidateById,
  submitMyrecord,
  PostComment,
  terminationCandidate,
  cancelCandidate,
} from "../../../services/apiRequests";
import { groupLookup } from "../../../utils/helpers";
import {
  dashboard_api,
  renderCandidateStatus,
} from "../../../constance/DashboardJson";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, find } from "lodash";
import dayjs from "dayjs";
import useLoader from "../../../Loader/useLoader";
import { MarkUpTable } from "../../../CommonContainer/MarkUpTable";
import useAuth from "../../../hooks/useAuth";
import { B2BIMariginLimits } from "../../../CommonContainer/B2BIMariginLimits";
import { PayBenefits } from "../../../CommonContainer/PayBenefits";
import { useScreenId } from "../../../hooks/useScreenId";
import CircleIcon from "@mui/icons-material/Circle";
import toast from "react-hot-toast";
import { Controller, useForm } from "react-hook-form";
import CoTextField from "../../../components/CoTextField";
import Field from "../../../components/Field";
import CoDropdown from "../../../components/CoDropdown/CoDropdown";
import CoDatePicker from "../../../components/CoDatePicker";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import {
  alphaNumeric,
  decimalValue,
  formatCurrency,
  number,
  onlyAlphabetWithSpace,
} from "../../../utils/normalizers";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const SquareRadio = styled(Radio)(({ theme }) => ({
  "& .MuiSvgIcon-root": {
    borderRadius: "0%",
    width: "20px",
    marginLeft: "3px",
    height: "20px",
  },
  "&.Mui-checked .MuiSvgIcon-root": {
    borderRadius: "0%",
    width: "20px",
    height: "20px",
  },
}));

const useStyles = makeStyles((theme) => ({
  usFlag: {
    width: "40px",
    height: "24px",
    background: `url(${usflag})`,
    backgroundColor: "lightgray",
    backgroundPosition: "-2.977px -4.849px",
    backgroundSize: "112.59% 140.42%",
    backgroundRepeat: "no-repeat",
  },
  CANADAflag: {
    width: "40px",
    height: "24px",
    background: `url(${CANADAflag})`,
    backgroundColor: "lightgray",
    backgroundPosition: "-2.977px -4.849px",
    backgroundSize: "112.59% 140.42%",
    backgroundRepeat: "no-repeat",
  },
}));

const ViewMyDbv2 = () => {
  const { getAccess } = useAuth();
  const { noAccess: totalComoer24 } = getAccess("10");
  const { noAccess: reMntlyCmsPH } = getAccess("11");
  const { noAccess: tcmnsPH } = getAccess("12");
  const { noAccess: hrlyRate } = getAccess("13");
  const { noAccess: Boarding } = getAccess("15");
  const { noAccess: termination } = getAccess("16");
  const { noAccess: calcCountry } = getAccess("17");
  const { canReadWrite: accessForAP } = getAccess("26");
  const { canReadWrite: calcelButton } = getAccess("28");

  const visibleAccess = {
    recuiterMonthlyCommissionPerHour: totalComoer24,
    totalCommissionForMonthPro: reMntlyCmsPH,
    recruiterMonthlyCommissionPro: tcmnsPH,
    hourlyRate: hrlyRate,
    onboardingDt: Boarding,
    terminationDt: termination,
    calculationCountry: calcCountry,
  };

  const navigate = useNavigate();
  const [calculatedOnce, setCalculatorOnce] = useState(false);
  const [dataChanged, setDataChanged] = useState();
  const [candidateDetails, setCandidateDetails] = useState({});
  const [holidayToggle, setHoliddayToggle] = useState(false);
  const [cancelDialog, setCancelDialog] = useState(false);
  const [holidayDataToggle, setHolidayDataTggle] = useState({});
  const employIntegration = useSelector((state) => {
    return state.dropedField;
  });
  const candidateList = useSelector((state) => state.dropedField);
  const [vmsForBu, setvmsForBu] = useState();
  const authRedux = useSelector((state) => state.auth);
  const [lookupGroup, setLookupGroup] = useState({});
  const [wholeRawlookup, setWholeRawlookup] = useState([]);
  const [VMSFee, setVmsFee] = useState([]);
  const [apiIntegrated, setApiIntegrated] = useState(false);
  const dispatch = useDispatch();
  const [showLoader, hideLoader] = useLoader();
  const [alignment, setAlignment] = useState("USA");
  const [tabIndex, setTabIndex] = useState(0);
  const [open, setOpen] = useState(false);

  const classes = useStyles();

  useScreenId(
    3,
    () => {
      vmsValue();
    },
    [],
    [apiIntegrated],
    [employIntegration]
  );

  const findFullform = (shortHand) => {
    const status = lookupGroup["CANDIDATE_STATUS"];
    const longHand = find(status, (key) => key.value === shortHand);
    return longHand?.label;
  };

  const userSchema = yup.object({
    candidateName: yup.string().required("Enter Candidate Name"),
    candidateJobTitle: yup.string().required("Enter Candidate Job Title"),
    candidateStartDt: yup.string().required("Please Select the date"),
    candidateBillRate: yup.string().required("Enter Bill Rate"),
    payRate: yup.string().required("Enter Pay Rate"),
    candidateCountry: yup.string().required("Select Working Location"),
    candidateBusinessUnit: yup.string().required("Select Business Unit"),
    candidateTypeOfResource: yup.string().required("Select Resource Type"),
    vmsFee: yup.string().required("Select VMS Fee"),
    vacationNoOfDays: yup
      .string()
      .when(["candidateCountry", "candidateTypeOfResource"], {
        is: (country, type) => country === "CAD" || type !== "C2C",
        then: (schema) => schema.required("Enter Vacation Days"),
      }),

    sickLeaveNoOfDays: yup.string().when("candidateTypeOfResource", {
      is: (type) => type !== "C2C",
      then: (schema) => schema.required("Enter Sick Leave Days"),
    }),
    provinceState: yup.string().when("candidateCountry", {
      is: (type) => type === "CAD",
      then: (schema) => schema.required("Select Provience State"),
    }),
    refferalAmount: yup.string().when("candidateTypeOfResource", {
      is: (type) => type !== "C2C",
      then: (schema) => schema.required("Enter Referral Amount"),
    }),
    immgirationType: yup
      .string()
      .when(["candidateCountry", "candidateTypeOfResource"], {
        is: (country, type) => country === "CAD" || type !== "C2C",
        then: (schema) => schema.required("Enter Immigration Type"),
      }),

    otherExpenses: yup.string().when("candidateTypeOfResource", {
      is: (type) => type !== "C2C",
      then: (schema) => schema.required("Enter Other Expenses"),
    }),
    candidateInsurenceType: yup
      .string()
      .when(["candidateTypeOfResource", "candidateCountry"], {
        is: (type, country) => type !== "C2C" || country === "CAD",
        then: (schema) => schema.required("Select Insurance Type"),
      }),
    holidays: yup
      .string()
      .when(["candidateCountry", "candidateTypeOfResource"], {
        is: (country, type) => country === "CAD" || type !== "C2C",
        then: (schema) => schema.required("Select Holidays"),
      }),
    otherExpensesHourly: yup
      .string()
      .when(["candidateTypeOfResource", "candidateCountry"], {
        is: (type, country) => type !== "C2C" || country === "CAD",
        then: (schema) => schema.required("Enter Other Expenses Hourly"),
      }),
    leaveStateCd: yup.string().when("candidateCountry", {
      is: "USA",
      then: (schema) => schema.required("Select State"),
      otherwise: (schema) => schema.notRequired(), // Ensure fallback behavior
    }),
    comment: yup.string().when([], {
      is: () => candidateDetails?.candidateStatus === "ONB" || calcelButton,
      then: (schema) => schema.required("Enter Comment"),
    }),
    terminationDt: yup.string().when([], {
      is: () => candidateDetails?.candidateStatus === "ONB" && !calcelButton,
      then: (schema) => schema.required("Choose Termination Date"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  const {
    control,
    getValues,
    watch,
    setValue,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(userSchema),
    defaultValues: {
      ...candidateDetails,
      candidateStartDt: candidateDetails?.candidateStartDt
        ? dayjs(candidateDetails?.candidateStartDt, "YYYY-MM-DD")
        : null,
      onboardingDt: candidateDetails?.onboardingDt
        ? dayjs(candidateDetails?.onboardingDt, "YYYY-MM-DD")
        : null,
      terminationDt: candidateDetails?.terminationDt
        ? dayjs(candidateDetails?.terminationDt, "YYYY-MM-DD")
        : null,
      candidateDetailId: candidateDetails?.candidateDetailId ?? null,
      comment: "",
    },
  });

  useEffect(() => {
    if (candidateDetails) {
      reset({
        ...candidateDetails,
        candidateStartDt: candidateDetails?.candidateStartDt
          ? dayjs(candidateDetails?.candidateStartDt, "YYYY-MM-DD")
          : null,
        onboardingDt: candidateDetails?.onboardingDt
          ? dayjs(candidateDetails?.onboardingDt, "YYYY-MM-DD")
          : null,
        terminationDt: candidateDetails?.terminationDt
          ? dayjs(candidateDetails?.terminationDt, "YYYY-MM-DD")
          : null,
        candidateDetailId: candidateDetails?.candidateDetailId ?? null,
      });
    }
  }, [candidateDetails, reset]);

  const commentData = watch("comment");
  const immigration = watch("immgirationType");
  const tnVisaCountry = watch("tnVisaCountry");
  const businessUnit = watch("candidateBusinessUnit");
  const workingLocation = watch("candidateCountry");
  const leaveStateCd = watch("leaveStateCd");
  const calCountry = watch("calculationCountry");
  const vmsFee = watch("vmsFee");
  const tnVisa = watch("tnVisaCountry");

  const openCancelDilog = () => {
    setCancelDialog(true);
  };

  const closeCancelDilog = () => {
    setCancelDialog(false);
  };

  const vmsValue = async () => {
    try {
      showLoader();
      if (
        employIntegration.userAction === "View" ||
        employIntegration.userAction === "Edit"
      ) {
        let response = await getCandidateById(
          "getbycandidateid",
          employIntegration.id
        );
        dispatch(setMatchedLookupobj(response.data));
        if (response.data.hasOwnProperty("candidateDetailId")) {
          setCalculatorOnce(true);
          setDataChanged(true);
        }

        if (response.data.hasOwnProperty("candidateDetailId")) {
          setCalculatorOnce(true);
          setDataChanged(true);
        }

        if (
          candidateList.lookup &&
          Object.keys(candidateList.lookup).length > 0
        ) {
          setWholeRawlookup(candidateList.lookup);
          const BuforVms = candidateList.vmsFee.reduce((acc, current) => {
            if (acc[current.bussinessUnit]) {
              acc[current.bussinessUnit].push({
                label: current.customerNameWithFee,
                value: current.vmsId,
                markup: current.allowedMarkupPct,
              });
            } else {
              acc[current.bussinessUnit] = [
                {
                  label: current.customerNameWithFee,
                  value: current.vmsId,
                  markup: current.allowedMarkupPct,
                },
              ];
            }

            return acc;
          }, {});
          setvmsForBu(BuforVms);
          const vmsFor = BuforVms[response.data.candidateBusinessUnit]
            ? BuforVms[response.data.candidateBusinessUnit]
            : [];
          setVmsFee({ VMS: vmsFor });
          const groupedLookup = groupLookup(candidateList.lookup);
          //   matchWithValues(response.data, groupedLookup, vmsArray);
          setCandidateDetails({ ...response.data });
          setLookupGroup(groupedLookup);
        }
      } else if (employIntegration.userAction === "Post") {
        setCandidateDetails({ ...dashboard_api });
      }
    } catch (error) {
    } finally {
      hideLoader();
    }
  };

  const terminationCnd = async () => {
    try {
      showLoader();

      const payload = {
        applicationId: candidateDetails.applicationId,
        terminationDt:
          candidateDetails.terminationDt ||
          dayjs(getValues("terminationDt")).toISOString(),
        candidateStatus: "Terminated",
        candidateDetailId: candidateDetails.candidateDetailId,
      };
      const res = await terminationCandidate(payload);
      if (res.status === 200) {
        toast.success(`${candidateDetails.candidateName} is Terminated`);
        setBackTodashboard();
      }
    } catch (error) {
    } finally {
      hideLoader();
    }
  };

  const cancelCnd = async () => {
    try {
      showLoader();
      const payload = {
        commentDesc:
          commentData === "" ? candidateDetails.comments : commentData,
        applicationId: candidateDetails.applicationId,
      };
      const commentRes = await PostComment(payload);
      if (commentRes.status === 200) {
        reset((prevValues) => ({
          ...prevValues,
          comment: payload.commentDesc,
        }));
        const res = await cancelCandidate(payload.applicationId);
        if (res?.status === 200) {
          toast.success(`canceled successfully `);
          closeCancelDilog();
          setBackTodashboard();
        }
      }
    } catch (error) {
      console.error("Error saving comment:", error);
      if (error?.response) {
        toast.error(
          error?.response.data?.message ||
            "Something went wrong. Please try again."
        );
      } else if (error?.request) {
        toast.error("Network error. Please check your internet connection.");
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    } finally {
      hideLoader();
    }
  };

  const saveComment = async (data) => {
    try {
      showLoader();
      const payload = {
        commentDesc: commentData === "" ? data.comments : commentData,
        applicationId: data.applicationId,
      };
      const commentRes = await PostComment(payload);
      if (commentRes.status === 200) {
        reset((prevValues) => ({
          ...prevValues,
          comment: payload.commentDesc,
        }));
      }
    } catch (error) {
    } finally {
      hideLoader();
    }
  };

  const saveAndpost = async (data) => {
    try {
      showLoader();
      const payload = {
        ...data,
        calculationCountry:
          candidateList.loginData.roleCd === "RCTR" ||
          candidateList.loginData.roleCd === "ACCMNGR" ||
          candidateList.loginData.country === "India"
            ? candidateList.loginData.country
            : data.calculationCountry,

        candidateBusinessUnit:
          data.candidateTypeOfResource === "C2C"
            ? data.candidateBusinessUnit || null
            : data.candidateBusinessUnit,

        holidays:
          data.candidateTypeOfResource === "C2C" ||
          data.candidateCountry === "CAD"
            ? data.holidays || "NO"
            : data.holidays,

        candidateInsurenceType:
          data.candidateTypeOfResource === "C2C" ||
          data.candidateCountry === "CAD"
            ? data.candidateInsurenceType || "NON"
            : data.candidateInsurenceType,

        immgirationType:
          data.candidateTypeOfResource === "C2C" ||
          data.candidateCountry === "CAD"
            ? data.immgirationType || "NO"
            : data.immgirationType,

        vacationNoOfDays:
          data.candidateTypeOfResource === "C2C" ||
          data.candidateCountry === "CAD"
            ? data.vacationNoOfDays && data.vacationNoOfDays >= 0
              ? parseInt(data.vacationNoOfDays)
              : 0
            : data.vacationNoOfDays || 0,

        sickLeaveNoOfDays:
          data.candidateTypeOfResource === "C2C" ||
          data.candidateCountry === "CAD"
            ? data.sickLeaveNoOfDays && data.sickLeaveNoOfDays >= 0
              ? parseInt(data.sickLeaveNoOfDays)
              : 0
            : data.sickLeaveNoOfDays || 0,

        otherExpenses:
          data.candidateTypeOfResource === "C2C"
            ? data.otherExpenses && data.otherExpenses >= 0
              ? parseInt(data.otherExpenses)
              : 0
            : data.otherExpenses || 0,

        otherExpensesHourly:
          data.candidateTypeOfResource === "C2C" ||
          data.candidateCountry === "CAD"
            ? data.otherExpensesHourly && data.otherExpensesHourly >= 0
              ? parseInt(data.otherExpensesHourly)
              : 0
            : data.otherExpensesHourly || 0,

        refferalAmount:
          data.candidateTypeOfResource === "C2C"
            ? data.refferalAmount && data.refferalAmount >= 0
              ? parseInt(data.refferalAmount)
              : 0
            : data.refferalAmount || 0,

        recruiterCountry:
          candidateList.loginData.roleCd === "RCTR" ||
          candidateList.loginData.roleCd === "ACCMNGR" ||
          candidateList.loginData.country === "India"
            ? candidateList.loginData.country
            : candidateList.loginData.roleCd === "ADMN" ||
              candidateList.loginData.roleCd === "HR" ||
              candidateList.loginData.roleCd === "ACCEXCTL1" ||
              candidateList.loginData.roleCd === "SPADMN"
            ? data.calculationCountry
            : "",

        loginUserId: candidateList.loginData.id,

        candidateStartDt: data?.candidateStartDt
          ? dayjs(data?.candidateStartDt).format("YYYY-MM-DD")
          : null,
        onboardingDt: data?.onboardingDt
          ? dayjs(data?.onboardingDt).format("YYYY-MM-DD")
          : null,
        terminationDt: data?.terminationDt
          ? dayjs(data?.terminationDt).format("YYYY-MM-DD")
          : null,
        perDiemCount:
          candidateDetails.perDiemCount !== ""
            ? candidateDetails.perDiemCount
            : 0,
        candidateStatus:
          candidateDetails.candidateStatus === "NCR"
            ? "PEN"
            : candidateDetails.candidateStatus,
      };
      const dataRes = await updateCandidateById(
        payload.candidateDetailId,
        payload
      );

      if (dataRes.status === 200) {
        setCalculatorOnce(true);
        dispatch(
          setDashboardChild({
            id: dataRes.data.candidateDetailId,
            userAction: "Edit",
            userName: dataRes.data.candidateName,
          })
        );
        dispatch(setMatchedLookupobj(dataRes?.data));

        reset({
          ...dataRes.data,
          candidateStartDt: dataRes?.data?.candidateStartDt
            ? dayjs(dataRes?.data?.candidateStartDt).format("YYYY-MM-DD")
            : null,
          onboardingDt: dataRes?.data?.onboardingDt
            ? dayjs(dataRes?.data?.onboardingDt).format("YYYY-MM-DD")
            : null,
          terminationDt: dataRes?.data?.terminationDt
            ? dayjs(dataRes?.data?.terminationDt).format("YYYY-MM-DD")
            : null,
        });
        setApiIntegrated(!apiIntegrated);
        setCandidateDetails(dataRes.data);
        if (
          candidateDetails.candidateStatus === "CMP" ||
          // candidateDetails.candidateStatus === "SUB" ||
          candidateDetails.candidateStatus === "ONB"
        ) {
          saveComment(candidateDetails);
        }
      }
    } catch (error) {
      console.error("Error saving comment:", error);

      if (error?.response) {
        toast.error(
          error?.response.data?.message ||
            "Something went wrong. Please try again."
        );
      } else if (error?.request) {
        toast.error("Network error. Please check your internet connection.");
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    } finally {
      hideLoader();
    }
  };

  function setBackTodashboard() {
    setCandidateDetails({ ...dashboard_api });
    // navigate(Routepath.DashboardTabsAll);
    navigate(-1);
    dispatch(
      setDashboardChild({
        userAction: "",
        id: "",
        userName: "",
      })
    );
  }

  const ClearEvent = () => {
    vmsValue();
    reset();
  };

  const submitmyEdit = async (data) => {
    try {
      showLoader();
      const payload = {
        ...data,
        calculationCountry:
          candidateList.loginData.roleCd === "RCTR" ||
          candidateList.loginData.roleCd === "ACCMNGR" ||
          candidateList.loginData.country === "India"
            ? candidateList.loginData.country
            : data.calculationCountry,

        candidateBusinessUnit:
          data.candidateTypeOfResource === "C2C"
            ? data.candidateBusinessUnit || null
            : data.candidateBusinessUnit,

        holidays:
          data.candidateTypeOfResource === "C2C" ||
          data.candidateCountry === "CAD"
            ? data.holidays || "NO"
            : data.holidays,

        candidateInsurenceType:
          data.candidateTypeOfResource === "C2C" ||
          data.candidateCountry === "CAD"
            ? data.candidateInsurenceType || "NON"
            : data.candidateInsurenceType,

        immgirationType:
          data.candidateTypeOfResource === "C2C" ||
          data.candidateCountry === "CAD"
            ? data.immgirationType || "NO"
            : data.immgirationType,

        vacationNoOfDays:
          data.candidateTypeOfResource === "C2C" ||
          data.candidateCountry === "CAD"
            ? data.vacationNoOfDays && data.vacationNoOfDays >= 0
              ? parseInt(data.vacationNoOfDays)
              : 0
            : data.vacationNoOfDays || 0,

        sickLeaveNoOfDays:
          data.candidateTypeOfResource === "C2C" ||
          data.candidateCountry === "CAD"
            ? data.sickLeaveNoOfDays && data.sickLeaveNoOfDays >= 0
              ? parseInt(data.sickLeaveNoOfDays)
              : 0
            : data.sickLeaveNoOfDays || 0,

        otherExpenses:
          data.candidateTypeOfResource === "C2C"
            ? data.otherExpenses && data.otherExpenses >= 0
              ? parseInt(data.otherExpenses)
              : 0
            : data.otherExpenses || 0,

        otherExpensesHourly:
          data.candidateTypeOfResource === "C2C" ||
          data.candidateCountry === "CAD"
            ? data.otherExpensesHourly && data.otherExpensesHourly >= 0
              ? parseInt(data.otherExpensesHourly)
              : 0
            : data.otherExpensesHourly || 0,

        refferalAmount:
          data.candidateTypeOfResource === "C2C"
            ? data.refferalAmount && data.refferalAmount >= 0
              ? parseInt(data.refferalAmount)
              : 0
            : data.refferalAmount || 0,

        recruiterCountry:
          candidateList.loginData.roleCd === "RCTR" ||
          candidateList.loginData.roleCd === "ACCMNGR" ||
          candidateList.loginData.country === "India"
            ? candidateList.loginData.country
            : candidateList.loginData.roleCd === "ADMN" ||
              candidateList.loginData.roleCd === "HR" ||
              candidateList.loginData.roleCd === "ACCEXCTL1" ||
              candidateList.loginData.roleCd === "SPADMN"
            ? data.calculationCountry
            : "",

        loginUserId: candidateList.loginData.id,

        candidateStartDt: data?.candidateStartDt
          ? dayjs(data?.candidateStartDt).format("YYYY-MM-DD")
          : null,
        onboardingDt: data?.onboardingDt
          ? dayjs(data?.onboardingDt).format("YYYY-MM-DD")
          : null,
        terminationDt: data?.terminationDt
          ? dayjs(data?.terminationDt).format("YYYY-MM-DD")
          : null,
        perDiemCount:
          candidateDetails.perDiemCount !== ""
            ? candidateDetails.perDiemCount
            : 0,
        candidateStatus:
          candidateDetails.candidateStatus === "NCR"
            ? "PEN"
            : candidateDetails.candidateStatus,
      };

      const respondse = await submitMyrecord(
        candidateDetails.candidateDetailId,
        payload
      );
      if (respondse.status === 200) {
        setBackTodashboard();
      }
    } catch (error) {
      console.error("Error saving comment:", error);
      if (error.response) {
        toast.error(
          error.response.data?.message ||
            "Something went wrong. Please try again."
        );
      } else if (error.request) {
        toast.error("Network error. Please check your internet connection.");
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    } finally {
      hideLoader();
    }
  };

  const displayRules = (name) => {
    let BooleanResult = true;

    if (["Allowance"].includes(name)) {
      workingLocation === "CAD"
        ? (BooleanResult = false)
        : (BooleanResult = true);
    }
    if (["Total Commission for # months"].includes(name)) {
      candidateList.loginData.country === "India"
        ? (BooleanResult = false)
        : (BooleanResult = true);
    }

    if (["calculationCountry"].includes(name)) {
      candidateList.loginData.country === "India"
        ? (BooleanResult = false)
        : (BooleanResult = true);
    }
    if (["recMnthlyCommissionBonus"].includes(name)) {
      candidateList.loginData.country === "India"
        ? (BooleanResult = true)
        : (BooleanResult = false);
    }
    if (name === "leaveStateCd") {
      workingLocation === "USA"
        ? (BooleanResult = true)
        : (BooleanResult = false);
    }
    if (
      [
        "provinceState",
        "statutoryHolidays",
        "vacationPayHourly",
        "vacationPayAnnual",
        "optionalHolidays",
        "ttlMonthlyCommissionUSDVal",
        "recruiterMonthlyCommissionUSDVal",
      ].includes(name)
    ) {
      workingLocation === "CAD"
        ? (BooleanResult = true)
        : (BooleanResult = false);
    }
    if (
      [
        "ttlMonthlyCommissionUSDVal",
        "recruiterMonthlyCommissionUSDVal",
      ].includes(name)
    ) {
      if (
        workingLocation === "CAD" &&
        candidateList.loginData.country === "USA"
      ) {
        BooleanResult = true;
      } else BooleanResult = false;
    }
    if (
      [
        "ttlMonthlyCommissionUSDVal",
        "recruiterMonthlyCommissionUSDVal",
      ].includes(name)
    ) {
      if (
        workingLocation === "CAD" &&
        candidateList.loginData.country === "India"
      ) {
        BooleanResult = false;
      }
    }
    if (
      [
        "vacationNoOfDays",
        "candidateInsurenceType",
        "holidays",
        "immgirationType",
        "otherExpensesHourly",
        // "totalCommissionForMonthPro",
        // "recruiterMonthlyCommissionPro",
        "hourlyRate",
        "perDiemCount",
        "perDiem",
        "payRatePerDiem",
        "recruiterMonthlyCommission",
        "recuiterMonthlyCommissionPerHour",
      ].includes(name)
    ) {
      workingLocation === "CAD"
        ? (BooleanResult = false)
        : (BooleanResult = true);
    }

    return BooleanResult;
  };

  const setMydivName = (name, divName) => {
    let myDivName = "";

    if (calCountry === "CAD" || candidateList.loginData.country === "Canada") {
      switch (name) {
        case "recuiterMonthlyCommission": {
          myDivName = "Recruiter Monthly Commission(CAD)";
          break;
        }
        case "totalCommissionFor24Months": {
          myDivName = "Total Commission for # months (CAD)";
          break;
        }
        default:
          myDivName = divName;
      }
    } else myDivName = divName;

    return myDivName;
  };

  const chooseDropdoenOptions = (type) => {
    let filteredOption = lookupGroup[type];
    if (type === "BUSINESSUNIT") {
      if (workingLocation === "CAD") {
        const filteredOptions = lookupGroup["BUSINESSUNIT"].filter((key) =>
          ["Canada", "BU07", "BU01"].includes(key.value)
        );
        filteredOption = filteredOptions;
      } else {
        const filteredOptions = lookupGroup["BUSINESSUNIT"].filter(
          (key) => !["Canada"].includes(key.value)
        );
        filteredOption = filteredOptions;
      }
    }
    if (type === "RESOURCETYPE") {
      if (workingLocation === "CAD") {
        const filteredOptions = lookupGroup["RESOURCETYPE"].filter(
          (key) => key.value === "T4" || key.value === "C2C"
        );
        filteredOption = filteredOptions;
      } else {
        const filteredOptions = lookupGroup["RESOURCETYPE"].filter(
          (key) => key.value !== "T4"
        );

        filteredOption = filteredOptions;
      }
    }
    return filteredOption;
  };

  const currencySymbol = () => {
    const calCountry = watch("calculationCountry");
    const commissionCurrency =
      candidateList.loginData.roleCd !== "RCTR" ||
      candidateList.loginData.roleCd !== "ACCMNGR"
        ? calCountry === "India"
          ? "IND"
          : calCountry === "USA"
          ? "USA"
          : candidateList.loginData.country === "India"
          ? "IND"
          : candidateList.loginData.country === "USA"
          ? "USA"
          : "CAD"
        : "USA";

    return commissionCurrency === "IND" ? "₹" : "$";
  };

  useEffect(() => {
    if (leaveStateCd && candidateDetails.leaveStateCd !== leaveStateCd) {
      const constFindObj = wholeRawlookup.find(
        (obj) => obj.lookupCd === leaveStateCd
      );
      setHolidayDataTggle(constFindObj);

      if (constFindObj?.lookupVal === "0") {
        setHoliddayToggle(false);
      } else {
        setValue("vacationNoOfDays", constFindObj?.lookupVal ?? "0");
        setHoliddayToggle(true);
      }
    }
  }, [leaveStateCd, candidateDetails, setValue, wholeRawlookup]);

  useEffect(() => {
    if (!businessUnit || !vmsForBu) return; // Ensure vmsForBu is defined
    const vmsFor = vmsForBu[businessUnit] ?? []; // Use optional chaining or fallback
    if (vmsFor.length > 0) {
      setValue("vmsFee", vmsFee || ""); // Set first option as default
    } else {
      setValue("vmsFee", ""); // Clear selection if no options
    }
    setVmsFee({ VMS: vmsFor });
  }, [businessUnit, vmsForBu, setValue]); // Add dependency on vmsForBu

  useEffect(() => {
    const recruiterSplit = authRedux.token.userName.split(" ");
    setValue("recuiterFirstName", recruiterSplit[0]);
    setValue("recuiterLastName", recruiterSplit[1]);
  }, [authRedux, setValue]);

  useEffect(() => {
    if (immigration !== 4000) {
      setValue("tnVisaCountry", ""); // Reset country field
      setValue("tnVisaPremiumYN", ""); // Reset premium field
    }
  }, [immigration, setValue]); // Runs when immigration changes

  useEffect(() => {
    if (!businessUnit || !vmsForBu || !vmsForBu.hasOwnProperty(businessUnit))
      return;

    const getMarkup = vmsForBu[businessUnit]?.find(
      (obj) => obj.value === vmsFee
    );

    setValue(
      "allowedMarkupPct",
      getMarkup?.markup
        ? getMarkup?.markup === "NA"
          ? "No Markup"
          : getMarkup?.markup
        : "--"
    );
  }, [vmsFee, businessUnit, vmsForBu, setValue]);

  const terminDialogue = () => {
    toast.custom((t) => (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "16px",
          position: "absolute",
          top: "50%",
          borderRadius: "8px",
          background: "#fff",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div style={{ marginBottom: "8px" }}>
          <strong>Do you want to terminate this candidate?</strong>
        </div>
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <button
            style={{
              background: "#4CAF50",
              color: "white",
              padding: "8px 12px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={async () => {
              toast.dismiss(t.id);
              handleSubmit(terminationCnd, (errors) => {
                console.log("Validation Errors:", errors);
              })();
            }}
          >
            Yes
          </button>
          <button
            style={{
              background: "#f44336",
              color: "white",
              padding: "8px 12px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => {
              toast.dismiss(t.id); // Close toast
            }}
          >
            No
          </button>
        </div>
      </div>
    ));
  };

  useEffect(() => {
    if (workingLocation) {
      setAlignment(workingLocation);
    }
  }, [workingLocation]);

  const tabs = [
    candidateDetails?.rtMarkUpModel && { label: "Mark Up List", key: "markUp" },
    candidateDetails?.prFinalRateModel && {
      label: "Pay Benefits",
      key: "payBenefits",
    },
    candidateDetails?.rtMarkUpModel && {
      label: "B2BI Margin Limit",
      key: "b2bi",
    },
  ].filter(Boolean);

  useEffect(() => {
    if (!tnVisa) {
      setValue("tnVisaCountry", candidateDetails.tnVisaCountry ?? ""); // Set default value if it's empty
      setValue("tnVisaPremiumYN", candidateDetails.tnVisaPremiumYN ?? ""); // Set default value if it's empty
    }
  }, [tnVisa, setValue, candidateDetails, watch]);

  return (
    <>
      <Grid
        container
        sx={{
          background: "#44A0E3",
          p: 1,
          justifyContent: "flex-start",
          alignItems: "flex-start",
          position: "sticky",
          overflow: "auto",
          right: "10px",
          top: "100px",
          zIndex: 1,
        }}
      >
        <Grid item sx={{ display: "flex" }} xs={3}>
          <Typography variant="h7" sx={{ color: "#FFF" }}>
            Application Id:
          </Typography>
          <Typography variant="h7" sx={{ color: "#FFF" }}>
            {candidateDetails.applicationId}
          </Typography>
        </Grid>
        <Grid item sx={{ display: "flex" }} xs={3}>
          <Typography variant="h7" sx={{ color: "#FFF" }}>
            Candidate Name:
          </Typography>
          <Typography variant="h7" sx={{ color: "#FFF" }}>
            {candidateDetails.candidateName}
          </Typography>
        </Grid>
        <Grid item sx={{ display: "flex" }} xs={3}>
          <Typography variant="h7" sx={{ color: "#FFF" }}>
            Recruiter Name:
          </Typography>
          <Typography variant="h7" sx={{ color: "#FFF" }}>
            {candidateDetails.recuiterFirstName}{" "}
            {candidateDetails.recuiterLastName}
          </Typography>
        </Grid>
        <Grid item sx={{ display: "flex", gap: "2px" }} xs={3}>
          <Typography variant="h7" sx={{ color: "#FFF" }}>
            Candidate Status:
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <CircleIcon
              sx={{
                color:
                  renderCandidateStatus?.[
                    findFullform(candidateDetails?.candidateStatus)
                  ] ?? "white",
                width: "15px",
              }}
            />
            <Typography variant="h7" sx={{ color: "#FFF" }}>
              {findFullform(candidateDetails?.candidateStatus)}
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid container>
        {candidateDetails?.rtMarkUpModel && (
          <IconButton
            sx={{
              position: "fixed",
              top: 130,
              right: 20,
              background: "#616161",
              boxShadow: 2,
              color: "white",
              zIndex: 9999,
              "&:hover": {
                background: "#424242",
                color: "#f5f5f5",
                transform: "scale(1.1)",
                transition: "all 0.3s ease",
              },
            }}
            onClick={() => setOpen(true)}
          >
            <MonetizationOnOutlinedIcon />
          </IconButton>
        )}

        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            <Typography variant="h6">Candidate Details</Typography>
          </DialogTitle>
          <DialogContent sx={{ height: "25rem" }}>
            {tabs.length > 0 ? (
              <>
                <Tabs
                  value={tabIndex}
                  onChange={(e, newIndex) => setTabIndex(newIndex)}
                >
                  {tabs.map((tab, index) => (
                    <Tab key={index} label={tab.label} />
                  ))}
                </Tabs>
                {tabs[tabIndex]?.key === "markUp" && (
                  <Box p={2}>
                    <MarkUpTable value={candidateDetails?.rtMarkUpModel} />
                  </Box>
                )}

                {tabs[tabIndex]?.key === "payBenefits" && (
                  <Box p={2}>
                    <PayBenefits value={candidateDetails?.prFinalRateModel} />
                  </Box>
                )}

                {tabs[tabIndex]?.key === "b2bi" && (
                  <Box p={2}>
                    {!isEmpty(lookupGroup) && (
                      <B2BIMariginLimits value={lookupGroup} />
                    )}
                  </Box>
                )}
              </>
            ) : (
              <Typography>No Data Available</Typography>
            )}
          </DialogContent>
        </Dialog>
        <Grid item xs={12}>
          {!isEmpty(lookupGroup) ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "75%",
                  justifyContent: "center",
                  padding: "20px",
                }}
              >
                <ToggleButtonGroup
                  sx={{
                    backgroundColor: "#EEEEEE",
                    borderRadius: "15px ",
                    border: "solid 0.5px #616161",
                  }}
                  value={alignment}
                  exclusive
                  aria-label="Platform"
                >
                  <ToggleButton
                    value="USA"
                    sx={{
                      display: "flex",
                      gap: "10px",
                      textTransform: "capitalize",
                      "&.Mui-selected, &.Mui-selected:hover": {
                        backgroundColor: "#616161",
                      },
                      borderRadius: "14px",
                      backgroundColor: "white",
                    }}
                  >
                    <div className={classes.usFlag}></div>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontSize: 15,
                        fontWeight: alignment === "USA" ? "bold" : 500,
                        color: alignment === "USA" ? "#FFFF" : "#6c6c6c",
                      }}
                    >
                      United State
                    </Typography>
                  </ToggleButton>
                  <ToggleButton
                    value="CAD"
                    sx={{
                      display: "flex",
                      gap: "10px",
                      textTransform: "capitalize",
                      "&.Mui-selected, &.Mui-selected:hover": {
                        color: "#FFFF",
                        backgroundColor: "#616161",
                      },
                      borderRadius: "14px",
                      outline: alignment === "CAD" ? "solid 1px gray" : "none",
                      backgroundColor: "white",
                    }}
                  >
                    <div className={classes.CANADAflag}></div>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: alignment === "CAD" ? "bold" : 500,
                        color: alignment === "CAD" ? "#FFFF" : "#6c6c6c",
                      }}
                    >
                      Canada
                    </Typography>
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>

              <Grid container gap={2}>
                <Grid item xs={12}>
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      sx={{
                        border: "#D9D9D9 solid 1px",
                        boxShadow: "2px 2px 4px 0px rgba(1, 1, 22, 0.16)",
                      }}
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <Typography sx={{ fontWeight: 700 }}>
                        Employee Information
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Field
                            label="Candidate Name"
                            required
                            error={errors?.candidateName?.message}
                            showError={errors?.candidateName?.message}
                          >
                            <CoTextField
                              name="candidateName"
                              control={control}
                              normalizers={[onlyAlphabetWithSpace]}
                              disabled={
                                employIntegration.userAction === "View"
                                  ? true
                                  : false
                              }
                            />
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field
                            label="Job Title"
                            required
                            error={errors?.candidateJobTitle?.message}
                            showError={errors?.candidateJobTitle?.message}
                          >
                            <CoTextField
                              name="candidateJobTitle"
                              control={control}
                              normalizers={[alphaNumeric]}
                              disabled={
                                employIntegration.userAction === "View"
                                  ? true
                                  : false
                              }
                            />
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field label="Job ID">
                            <CoTextField
                              name="jobId"
                              control={control}
                              normalizers={[alphaNumeric]}
                              disabled={
                                employIntegration.userAction === "View"
                                  ? true
                                  : false
                              }
                            />
                          </Field>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Field
                            label="Start Date"
                            isDate
                            required
                            error={errors?.candidateStartDt?.message}
                            showError={errors?.candidateStartDt?.message}
                          >
                            <CoDatePicker
                              name="candidateStartDt"
                              control={control}
                              disabled={
                                employIntegration.userAction === "View"
                                  ? true
                                  : false
                              }
                            />
                          </Field>
                        </Grid>
                        {displayRules("onboardingDt") && (
                          <Grid item xs={4}>
                            <Field label="On Bording Date" isDate>
                              <CoDatePicker
                                name="onboardingDt"
                                control={control}
                                minDate={dayjs(getValues("candidateStartDt"))}
                                disabled={
                                  employIntegration.userAction === "View"
                                    ? true
                                    : false
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                        <Grid item xs={4}>
                          <Field
                            label="Termination Date"
                            isDate
                            required={
                              candidateDetails?.candidateStatus === "ONB"
                            }
                            error={errors?.terminationDt?.message}
                            showError={errors?.terminationDt?.message}
                          >
                            <CoDatePicker
                              name="terminationDt"
                              control={control}
                              minDate={dayjs().subtract(1, "week")}
                              maxDate={dayjs().add(1, "week")}
                              disabled={
                                employIntegration.userAction === "View"
                                  ? true
                                  : false
                              }
                            />
                          </Field>
                        </Grid>
                      </Grid>
                      <Grid item xs={4}></Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
                <Grid item xs={12}>
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      sx={{
                        border: "#D9D9D9 solid 1px",
                        boxShadow: "2px 2px 4px 0px rgba(1, 1, 22, 0.16)",
                      }}
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <Typography sx={{ fontWeight: 700 }}>
                        Billing & Staffing Information
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Field
                            label="Bill Rate"
                            required
                            error={errors?.candidateBillRate?.message}
                            showError={errors?.candidateBillRate?.message}
                          >
                            <CoTextField
                              name="candidateBillRate"
                              control={control}
                              normalizers={[formatCurrency]}
                              disabled={
                                employIntegration.userAction === "View"
                                  ? true
                                  : false
                              }
                              startAdornment={
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              }
                            />
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field
                            label="Pay Rate"
                            required
                            error={errors?.payRate?.message}
                            showError={errors?.payRate?.message}
                          >
                            <CoTextField
                              name="payRate"
                              control={control}
                              normalizers={[formatCurrency]}
                              disabled={
                                employIntegration.userAction === "View"
                                  ? true
                                  : false
                              }
                              startAdornment={
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              }
                            />
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field
                            label="Working Location"
                            required
                            error={errors?.candidateCountry?.message}
                            showError={errors?.candidateCountry?.message}
                          >
                            <CoDropdown
                              name="candidateCountry"
                              control={control}
                              disabled={
                                employIntegration.userAction === "View"
                                  ? true
                                  : false
                              }
                              options={chooseDropdoenOptions("COUNTRY")}
                            />
                          </Field>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        {displayRules("calculationCountry") &&
                          !visibleAccess["calculationCountry"] && (
                            <Grid item xs={4}>
                              <Field
                                label="Calculation Location"
                                required
                                error={errors?.calculationCountry?.message}
                                showError={errors?.calculationCountry?.message}
                              >
                                <CoDropdown
                                  name="calculationCountry"
                                  control={control}
                                  disabled={
                                    employIntegration.userAction === "View"
                                      ? true
                                      : false
                                  }
                                  options={chooseDropdoenOptions("CALCOUNTRY")}
                                />
                              </Field>
                            </Grid>
                          )}
                        {displayRules("leaveStateCd") && (
                          <Grid item xs={4}>
                            <Field
                              label="State"
                              required
                              error={errors?.leaveStateCd?.message}
                              showError={errors?.leaveStateCd?.message}
                            >
                              <CoDropdown
                                name="leaveStateCd"
                                control={control}
                                disabled={
                                  employIntegration.userAction === "View"
                                    ? true
                                    : false
                                }
                                options={chooseDropdoenOptions("STATE")}
                              />
                            </Field>
                          </Grid>
                        )}
                        <Grid item xs={4}>
                          <Field
                            label="Business Unit"
                            required
                            error={errors?.candidateBusinessUnit?.message}
                            showError={errors?.candidateBusinessUnit?.message}
                          >
                            <CoDropdown
                              name="candidateBusinessUnit"
                              control={control}
                              disabled={
                                employIntegration.userAction === "View"
                                  ? true
                                  : false
                              }
                              options={chooseDropdoenOptions("BUSINESSUNIT")}
                            />
                          </Field>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Field label="Recruiter Name">
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "14px",
                              }}
                            >
                              <CoTextField
                                name="recuiterFirstName"
                                control={control}
                                sx={{ width: "100%" }}
                                disabled={true}
                              />
                              <CoTextField
                                name="recuiterLastName"
                                control={control}
                                sx={{ width: "100%" }}
                                disabled={true}
                              />
                            </Box>
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field label="Pre-ID">
                            <CoDropdown
                              name="preId"
                              control={control}
                              disabled={
                                employIntegration.userAction === "View"
                                  ? true
                                  : false
                              }
                              options={chooseDropdoenOptions("YESNO")}
                            />
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field
                            label="Type of Resource"
                            required
                            error={errors?.candidateTypeOfResource?.message}
                            showError={errors?.candidateTypeOfResource?.message}
                          >
                            <CoDropdown
                              name="candidateTypeOfResource"
                              control={control}
                              disabled={
                                employIntegration.userAction === "View"
                                  ? true
                                  : false
                              }
                              options={chooseDropdoenOptions("RESOURCETYPE")}
                            />
                          </Field>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
                <Grid item xs={12}>
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      sx={{
                        border: "#D9D9D9 solid 1px",
                        boxShadow: "2px 2px 4px 0px rgba(1, 1, 22, 0.16)",
                      }}
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <Typography sx={{ fontWeight: 700 }}>
                        Compensation & Benefits Information
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Field
                            label="VMS Fee"
                            required
                            error={errors?.vmsFee?.message}
                            showError={errors?.vmsFee?.message}
                          >
                            <CoDropdown
                              name="vmsFee"
                              control={control}
                              disabled={
                                employIntegration.userAction === "View"
                                  ? true
                                  : false
                              }
                              options={VMSFee.VMS}
                            />
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field label="Allowed Markup">
                            <CoTextField
                              name="allowedMarkupPct"
                              control={control}
                              disabled={true}
                              isPercentage={true}
                            />
                          </Field>
                        </Grid>
                        {displayRules("holidays") && (
                          <Grid item xs={4}>
                            <Field
                              label="Holidays (6 Days)"
                              required
                              error={errors?.holidays?.message}
                              showError={errors?.holidays?.message}
                            >
                              <CoDropdown
                                name="holidays"
                                control={control}
                                disabled={
                                  employIntegration.userAction === "View"
                                    ? true
                                    : false
                                }
                                options={chooseDropdoenOptions("YESNO")}
                              />
                            </Field>
                          </Grid>
                        )}
                      </Grid>
                      {(displayRules("provinceState") ||
                        displayRules("vacationPayHourly") ||
                        displayRules("vacationPayAnnual")) && (
                        <Grid container spacing={2}>
                          {displayRules("provinceState") && (
                            <Grid item xs={4}>
                              <Field
                                label="Province State"
                                required={
                                  workingLocation === "CAD" ? true : false
                                }
                                error={errors?.provinceState?.message}
                                showError={errors?.provinceState?.message}
                              >
                                <CoDropdown
                                  name="provinceState"
                                  control={control}
                                  disabled={
                                    employIntegration.userAction === "View"
                                      ? true
                                      : false
                                  }
                                  options={chooseDropdoenOptions(
                                    "PROVINCES_STRY_HLDY"
                                  )}
                                />
                              </Field>
                            </Grid>
                          )}
                          {displayRules("vacationPayHourly") && (
                            <Grid item xs={4}>
                              <Field label="4% Vacation Pay Hourly">
                                <CoTextField
                                  name="vacationPayHourly"
                                  control={control}
                                  disabled
                                />
                              </Field>
                            </Grid>
                          )}
                          {displayRules("vacationPayAnnual") && (
                            <Grid item xs={4}>
                              <Field label="4% Vacation Pay Annual">
                                <CoTextField
                                  name="vacationPayAnnual"
                                  control={control}
                                  disabled
                                />
                              </Field>
                            </Grid>
                          )}
                        </Grid>
                      )}

                      <Grid container spacing={2}>
                        {displayRules("statutoryHolidays") && (
                          <Grid item xs={4}>
                            <Field label="Statutory Holidays">
                              <CoTextField
                                name="statutoryHolidays"
                                control={control}
                                normalizers={[number]}
                                disabled={
                                  employIntegration.userAction === "View"
                                    ? true
                                    : false
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                        {displayRules("vacationNoOfDays") && (
                          <Grid item xs={4}>
                            <Field
                              label="Vacation (# of Days)"
                              required
                              error={errors?.vacationNoOfDays?.message}
                              showError={errors?.vacationNoOfDays?.message}
                            >
                              <CoTextField
                                name="vacationNoOfDays"
                                control={control}
                                normalizers={[decimalValue]}
                                disabled={
                                  employIntegration.userAction === "View"
                                    ? true
                                    : false
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                        {displayRules("sickLeaveNoOfDays") && (
                          <Grid item xs={4}>
                            <Field label="Sick Leave (# of Days)">
                              <CoTextField
                                name="sickLeaveNoOfDays"
                                control={control}
                                normalizers={[number]}
                                disabled={
                                  employIntegration.userAction === "View"
                                    ? true
                                    : false
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                      </Grid>
                      <Grid container spacing={2}>
                        {displayRules("optionalHolidays") && (
                          <Grid item xs={4}>
                            <Field label="Optional Holidays">
                              <CoTextField
                                name="optionalHolidays"
                                control={control}
                                normalizers={[number]}
                                disabled={
                                  employIntegration.userAction === "View"
                                    ? true
                                    : false
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                        {displayRules("candidateInsurenceType") && (
                          <Grid item xs={4}>
                            <Field
                              label="Insurance Type"
                              required
                              error={errors?.candidateInsurenceType?.message}
                              showError={
                                errors?.candidateInsurenceType?.message
                              }
                            >
                              <CoDropdown
                                name="candidateInsurenceType"
                                control={control}
                                options={chooseDropdoenOptions("INSURENCE")}
                                disabled={
                                  employIntegration.userAction === "View"
                                    ? true
                                    : false
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                        {displayRules("refferalAmount") && (
                          <Grid item xs={4}>
                            <Field label="Referral Fee">
                              <CoTextField
                                name="refferalAmount"
                                control={control}
                                normalizers={[formatCurrency]}
                                disabled={
                                  employIntegration.userAction === "View"
                                    ? true
                                    : false
                                }
                                startAdornment={
                                  <InputAdornment position="start">
                                    $
                                  </InputAdornment>
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                      </Grid>
                      <Grid container spacing={2}>
                        {displayRules("immgirationType") && (
                          <Grid item xs={4}>
                            <Field
                              label="Immigration"
                              required
                              error={errors?.immgirationType?.message}
                              showError={errors?.immgirationType?.message}
                            >
                              <CoDropdown
                                name="immgirationType"
                                control={control}
                                disabled={
                                  employIntegration.userAction === "View"
                                    ? true
                                    : false
                                }
                                options={chooseDropdoenOptions("IMMIGRATION")}
                              />
                            </Field>
                          </Grid>
                        )}
                        {displayRules("otherExpenses") && (
                          <Grid item xs={4}>
                            <Field label="Other Exp-Fixed Dollar">
                              <CoTextField
                                name="otherExpenses"
                                control={control}
                                normalizers={[formatCurrency]}
                                disabled={
                                  employIntegration.userAction === "View"
                                    ? true
                                    : false
                                }
                                startAdornment={
                                  <InputAdornment position="start">
                                    $
                                  </InputAdornment>
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                        {displayRules("otherExpensesHourly") && (
                          <Grid item xs={4}>
                            <Field label="Other Expenses-Hourly">
                              <CoTextField
                                name="otherExpensesHourly"
                                control={control}
                                normalizers={[formatCurrency]}
                                disabled={
                                  employIntegration.userAction === "View"
                                    ? true
                                    : false
                                }
                                startAdornment={
                                  <InputAdornment position="start">
                                    $
                                  </InputAdornment>
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                      </Grid>
                      {immigration === "4000" ? (
                        <Grid container>
                          <Grid item xs={5}>
                            <Controller
                              name="tnVisaCountry"
                              control={control}
                              render={({ field }) => (
                                <RadioGroup row {...field}>
                                  <FormControlLabel
                                    label="Canada"
                                    value="CA"
                                    control={
                                      <Checkbox
                                        disabled={
                                          employIntegration.userAction ===
                                          "View"
                                            ? true
                                            : false
                                        }
                                        checked={field.value === "CA"}
                                        onChange={() =>
                                          setValue("tnVisaCountry", "CA")
                                        }
                                      />
                                    }
                                  />
                                  <FormControlLabel
                                    label="Mexico"
                                    value="MX"
                                    control={
                                      <Checkbox
                                        disabled={
                                          employIntegration.userAction ===
                                          "View"
                                            ? true
                                            : false
                                        }
                                        checked={field.value === "MX"}
                                        onChange={() =>
                                          setValue("tnVisaCountry", "MX")
                                        }
                                      />
                                    }
                                  />
                                </RadioGroup>
                              )}
                            />
                            <p style={{ color: "#d32f2f", fontSize: "0.8rem" }}>
                              {errors.tnVisaCountry?.message}
                            </p>

                            {tnVisaCountry && (
                              <>
                                <Controller
                                  name="tnVisaPremiumYN"
                                  control={control}
                                  render={({ field }) => (
                                    <RadioGroup row {...field}>
                                      <FormControlLabel
                                        label="Consulate"
                                        value="NO"
                                        control={
                                          <SquareRadio
                                            disabled={
                                              employIntegration.userAction ===
                                              "View"
                                                ? true
                                                : false
                                            }
                                          />
                                        }
                                      />
                                      <FormControlLabel
                                        label="Petition"
                                        value="YES"
                                        control={
                                          <SquareRadio
                                            disabled={
                                              employIntegration.userAction ===
                                              "View"
                                                ? true
                                                : false
                                            }
                                          />
                                        }
                                      />
                                    </RadioGroup>
                                  )}
                                />
                                <p
                                  style={{
                                    color: "#d32f2f",
                                    fontSize: "0.8rem",
                                  }}
                                >
                                  {errors.tnVisaPremiumYN?.message}
                                </p>
                              </>
                            )}
                          </Grid>
                        </Grid>
                      ) : (
                        ""
                      )}
                    </AccordionDetails>
                  </Accordion>
                </Grid>
                {displayRules("Total Commission for # months") &&
                  displayRules("Allowance") && (
                    <Grid item xs={12}>
                      <Accordion defaultExpanded>
                        <AccordionSummary
                          sx={{
                            border: "#D9D9D9 solid 1px",
                            boxShadow: "2px 2px 4px 0px rgba(1, 1, 22, 0.16)",
                          }}
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1-content"
                          id="panel1-header"
                        >
                          <Typography sx={{ fontWeight: 700 }}>
                            Commission & Allowance
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid container spacing={2}>
                            {displayRules("Total Commission for # months") && (
                              <Grid item xs={6}>
                                <Field
                                  label={setMydivName(
                                    "totalCommissionFor24Months",
                                    "Total Commission for # months"
                                  )}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      gap: "14px",
                                    }}
                                  >
                                    <CoTextField
                                      name="totalCommissionFor24Months"
                                      control={control}
                                      normalizers={[number]}
                                      disabled={
                                        employIntegration.userAction === "View"
                                          ? true
                                          : false
                                      }
                                      sx={{ width: "100%" }}
                                    />
                                    <CoTextField
                                      name="recuiterTotCommissionForMonths"
                                      control={control}
                                      sx={{ width: "100%" }}
                                      disabled={true}
                                      startAdornment={
                                        <InputAdornment position="start">
                                          {currencySymbol()}
                                        </InputAdornment>
                                      }
                                    />
                                  </Box>
                                </Field>
                              </Grid>
                            )}
                            {displayRules("Allowance") && (
                              <Grid item xs={6}>
                                <Field label="Allowance">
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      gap: "14px",
                                    }}
                                  >
                                    <CoTextField
                                      name="perDiemCount"
                                      control={control}
                                      normalizers={[number]}
                                      disabled={
                                        employIntegration.userAction === "View"
                                          ? true
                                          : false
                                      }
                                      sx={{ width: "100%" }}
                                    />
                                    <CoTextField
                                      name="perDiem"
                                      control={control}
                                      sx={{ width: "100%" }}
                                      disabled={true}
                                    />
                                  </Box>
                                </Field>
                              </Grid>
                            )}
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    </Grid>
                  )}
                <Grid item xs={12}>
                  <Accordion expanded={!!watch("maxPay")}>
                    <AccordionSummary
                      sx={{
                        border: "#D9D9D9 solid 1px",
                        boxShadow: "2px 2px 4px 0px rgba(1, 1, 22, 0.16)",
                      }}
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <Typography sx={{ fontWeight: 700 }}>
                        Pay & Expenses
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Field label="Max Pay (including Allowance)">
                            <CoTextField
                              name="maxPay"
                              control={control}
                              disabled={true}
                              startAdornment={
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              }
                            />
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field label="Pay Rate  Allowance">
                            <CoTextField
                              name="payRatePerDiem"
                              control={control}
                              disabled={true}
                              startAdornment={
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              }
                            />
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field label="B2BI Margin">
                            <CoTextField
                              name="b2biMargin"
                              control={control}
                              isPercentage={true}
                              disabled={true}
                            />
                          </Field>
                        </Grid>
                      </Grid>

                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Field label="Gross Margin">
                            <CoTextField
                              name="grossMarginPercentage"
                              control={control}
                              isPercentage={true}
                              colorind={candidateDetails.colorInd}
                              disabled={true}
                            />
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field label="Gross Margin in $">
                            <CoTextField
                              name="grossMarginDollar"
                              control={control}
                              disabled={true}
                              startAdornment={
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              }
                            />
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field label="Blended Gross Margin">
                            <CoTextField
                              name="blendedGrossMarginPercentage"
                              control={control}
                              isPercentage={true}
                              disabled={true}
                            />
                          </Field>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        {displayRules("recuiterMonthlyCommission") && (
                          <Grid item xs={4}>
                            <Field
                              label={setMydivName(
                                "recuiterMonthlyCommission",
                                "Recruiter Monthly Commission"
                              )}
                            >
                              <CoTextField
                                name="recuiterMonthlyCommission"
                                control={control}
                                disabled={true}
                                startAdornment={
                                  <InputAdornment position="start">
                                    {currencySymbol()}
                                  </InputAdornment>
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                        {displayRules("recMnthlyCommissionBonus") && (
                          <Grid item xs={4}>
                            <Field label="Recruiter Monthly Commission Bonus">
                              <CoTextField
                                name="recMnthlyCommissionBonus"
                                control={control}
                                disabled={true}
                                startAdornment={
                                  <InputAdornment position="start">
                                    {currencySymbol()}
                                  </InputAdornment>
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                        {displayRules("recuiterMonthlyCommissionPerHour") &&
                          (!visibleAccess["recuiterMonthlyCommissionPerHour"] &&
                          candidateDetails.candidateCountry !== "CAD" ? (
                            <Grid item xs={4}>
                              <Field label="Recruiter Monthly Commission per hour worked">
                                <CoTextField
                                  name="recuiterMonthlyCommissionPerHour"
                                  control={control}
                                  disabled={true}
                                  startAdornment={
                                    <InputAdornment position="start">
                                      $
                                    </InputAdornment>
                                  }
                                />
                              </Field>
                            </Grid>
                          ) : null)}
                      </Grid>
                      <Grid container spacing={2}>
                        {displayRules("totalCommissionForMonthPro") &&
                          (!visibleAccess["totalCommissionForMonthPro"] ? (
                            <Grid item xs={4}>
                              <Field label="Total AE Commission">
                                <CoTextField
                                  name="totalCommissionForMonthPro"
                                  control={control}
                                  disabled={true}
                                  startAdornment={
                                    <InputAdornment position="start">
                                      $
                                    </InputAdornment>
                                  }
                                />
                              </Field>
                            </Grid>
                          ) : null)}
                        {displayRules("recruiterMonthlyCommissionPro") &&
                          (!visibleAccess["recruiterMonthlyCommissionPro"] ? (
                            <Grid item xs={4}>
                              <Field label="AE Recruiter Monthly Commission">
                                <CoTextField
                                  name="recruiterMonthlyCommissionPro"
                                  control={control}
                                  disabled={true}
                                  startAdornment={
                                    <InputAdornment position="start">
                                      $
                                    </InputAdornment>
                                  }
                                />
                              </Field>
                            </Grid>
                          ) : null)}
                        {displayRules("ttlMonthlyCommissionUSDVal") && (
                          <Grid item xs={4}>
                            <Field label="Total Commission for # months (USD)">
                              <CoTextField
                                name="ttlMonthlyCommissionUSDVal"
                                control={control}
                                disabled={true}
                                startAdornment={
                                  <InputAdornment position="start">
                                    $
                                  </InputAdornment>
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                      </Grid>
                      <Grid container spacing={2}>
                        {displayRules("recruiterMonthlyCommissionUSDVal") && (
                          <Grid item xs={4}>
                            <Field label="Recruiter Monthly Commission(USD)">
                              <CoTextField
                                name="recruiterMonthlyCommissionUSDVal"
                                control={control}
                                disabled={true}
                                startAdornment={
                                  <InputAdornment position="start">
                                    $
                                  </InputAdornment>
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                        {displayRules("hourlyRate") &&
                          (!visibleAccess["hourlyRate"] &&
                          candidateDetails.candidateCountry !== "CAD" ? (
                            <Grid item xs={4}>
                              <Field label="Hourly Rate">
                                <CoTextField
                                  name="hourlyRate"
                                  control={control}
                                  disabled={true}
                                  startAdornment={
                                    <InputAdornment position="start">
                                      $
                                    </InputAdornment>
                                  }
                                />
                              </Field>
                            </Grid>
                          ) : null)}

                        {accessForAP &&
                          (candidateDetails?.candidateStatus === "CMP" ||
                            candidateDetails?.candidateStatus === "ONB" ||
                            calcelButton) && (
                            <Grid item xs={4} id="comments">
                              <Field
                                label="Comment"
                                required={
                                  candidateDetails?.candidateStatus === "ONB"
                                    ? true
                                    : false || calcelButton
                                }
                                error={errors?.comment?.message}
                                showError={errors?.comment?.message}
                              >
                                <CoTextField name="comment" control={control} />
                              </Field>
                            </Grid>
                          )}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "12px",
                    }}
                  >
                    {employIntegration.userAction !== "View" && (
                      <>
                        <Button
                          style={{
                            backgroundColor: "white",
                            color: "black",
                            border: "1px solid black",
                            textTransform: "capitalize",
                          }}
                          variant="contained"
                          onClick={ClearEvent}
                          value="Clear"
                        >
                          Clear
                        </Button>
                        <Button
                          style={{
                            color: !dataChanged && "grey",
                            pointerEvents: !dataChanged ? "none" : "auto",
                            backgroundColor: !dataChanged
                              ? "gainsboro"
                              : "#44a0e3",
                            textTransform: "capitalize",
                          }}
                          variant="contained"
                          onClick={() => {
                            handleSubmit(saveAndpost, (errors) => {
                              console.log("Validation Errors:", errors);
                            })();
                          }}
                        >
                          Update
                        </Button>
                        {candidateDetails?.candidateStatus !== "CMP" &&
                          candidateDetails?.candidateStatus !== "SUB" &&
                          candidateDetails?.candidateStatus !== "ONB" &&
                          calculatedOnce && (
                            <Button
                              variant="contained"
                              sx={{
                                textTransform: "capitalize",
                              }}
                              onClick={() => {
                                handleSubmit(submitmyEdit, (errors) => {
                                  console.log("Validation Errors:", errors);
                                })();
                              }}
                            >
                              Submit
                            </Button>
                          )}
                        {candidateDetails?.candidateStatus === "ONB" && (
                          <Button
                            variant="contained"
                            sx={{
                              textTransform: "capitalize",
                              backgroundColor: "#f5291b",
                              color: "#fff",
                              "&:hover": {
                                backgroundColor: "#d92016",
                              },
                            }}
                            // onClick={openTermDilog}
                            onClick={terminDialogue}
                          >
                            Terminate
                          </Button>
                        )}
                      </>
                    )}

                    {employIntegration.userAction === "View" && (
                      <Button
                        variant="outlined"
                        sx={{
                          textTransform: "capitalize",
                        }}
                        onClick={setBackTodashboard}
                      >
                        Back
                      </Button>
                    )}
                    {employIntegration.userAction === "View" &&
                      candidateList.visibleAccess === 1 &&
                      calcelButton && (
                        <Button
                          sx={{
                            textTransform: "capitalize",
                          }}
                          onClick={handleSubmit(openCancelDilog, (errors) => {
                            console.log("Validation Errors:", errors);
                          })}
                          color="error"
                          variant="contained"
                        >
                          Need Correction
                        </Button>
                      )}
                  </Box>
                </Grid>
              </Grid>
            </>
          ) : (
            <div style={{ alignItems: "center" }}> </div>
          )}
        </Grid>
      </Grid>
      {holidayToggle && (
        <Dialog open={holidayToggle}>
          <DialogContent>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                padding: "1rem",
                borderRadius: "0.2rem",
                border: "1px solid grey",
              }}
            >
              <WarningAmberRoundedIcon
                sx={{ width: "5rem", height: "5rem", color: "#FF6D00" }}
              />
              <Typography
                sx={{
                  fontSize: "1.5rem",
                  fontWeight: "bolder",
                }}
              ></Typography>
              <Typography sx={{ marginTop: "0.5rem" }}>
                There is mandatory paid leave in this state{" "}
                <span style={{ fontWeight: "bolder" }}>
                  {holidayDataToggle?.lookupLabel ?? " "}
                </span>
                .{"  "} Please add{" "}
                <span style={{ fontWeight: "bolder" }}>
                  {holidayDataToggle?.lookupVal ?? ""}
                </span>{" "}
                days in the vacation field
              </Typography>
              <Button
                sx={{
                  width: "6rem",
                  marginTop: "1rem",
                  textTransform: "capitalize",
                }}
                variant="contained"
                onClick={() => setHoliddayToggle(false)}
              >
                Ok
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      )}

      {cancelDialog && (
        <Dialog open={cancelDialog} onClose={closeCancelDilog}>
          <DialogContent>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                padding: "1rem",
                borderRadius: "0.2rem",
                border: "1px solid grey",
              }}
            >
              <WarningAmberRoundedIcon
                sx={{ width: "5rem", height: "5rem", color: "#FF6D00" }}
              />
              <Typography
                sx={{
                  fontSize: "1.5rem",
                  fontWeight: "bolder",
                }}
              ></Typography>
              <Typography sx={{ marginTop: "0.5rem" }}>
                Do you want to cancel this candidate
              </Typography>
              <DialogActions>
                <Button
                  onClick={cancelCnd}
                  variant="outlined"
                  sx={{
                    textTransform: "capitalize",
                  }}
                >
                  Yes
                </Button>
                <Button
                  sx={{
                    backgroundColor: "#f5291b",
                    color: "#fff",
                    "&:hover": {
                      backgroundColor: "#d92016",
                    },
                    textTransform: "capitalize",
                  }}
                  variant="contained"
                  onClick={closeCancelDilog}
                >
                  No
                </Button>
              </DialogActions>
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default ViewMyDbv2;
